define('utils/base64',{
    
    base64Chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    
    encode64: function(input) {
        input = escape(input);
        var output = '';
        var chr1, chr2, chr3 = '';
        var enc1, enc2, enc3, enc4 = '';
        var i = 0;

        do {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output + this.base64Chars.charAt(enc1) + this.base64Chars.charAt(enc2) + this.base64Chars.charAt(enc3) + this.base64Chars.charAt(enc4);
            chr1 = chr2 = chr3 = '';
            enc1 = enc2 = enc3 = enc4 = '';
        } while (i < input.length);

        return output;
    },
    decode64: function(input) {
        var output = [];
        var chr1, chr2, chr3 = '';
        var enc1, enc2, enc3, enc4 = '';
        var i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        var regexp = /[^A-Za-z0-9\+\/\=]/g;
        if (regexp.exec(input)) {
            return null;
        }

        do {
            enc1 = this.base64Chars.indexOf(input.charAt(i++));
            enc2 = this.base64Chars.indexOf(input.charAt(i++));
            enc3 = this.base64Chars.indexOf(input.charAt(i++));
            enc4 = this.base64Chars.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output.push(chr1 & 0xFF);
            if (enc3 != 64) {
                output.push(chr2 & 0xFF);
            }
            if (enc4 != 64) {
                output.push(chr3 & 0xFF);
            }

            chr1 = chr2 = chr3 = '';
            enc1 = enc2 = enc3 = enc4 = '';
        } while (i < input.length);

        return output;
    }
});

